import router from '../../router/'

const state = {
  login: false,
  user: {
    userName: null,
    pushId: null
  }

}
const mutations = {
  login (state, login) {
    state.login = login
  },
  user(state, User) {
    state.user = User
  }
}
const actions = {
  login ({commit}, login) {
    commit('login', login)
    const Storage = window.sessionStorage
    Storage.setItem('login', login)
    if (login) {
      router.push('/packages')
    }else{
      router.push('/')
    }
    
  },
  logout ({commit}) {
    commit('login', false)
    const Storage = window.sessionStorage
    Storage.setItem('login', false)
    router.push('/')
  },
  setUser ({commit}, User) {
    commit('user', User)
  },
}
const getters = {
  login: state => {
    return state.login
  },
  user: state => {
    return state.user
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}
